import store from '@shared/store/index';
import { computed } from 'vue';
import { useScreenSize } from '@shared/composables/screenWidth/useScreenSize';

const { isLessThanLG } = useScreenSize();

export function usePlayerStates() {
  const isPlayerOpenAdaptive = computed(() => {
    return store.state.Audioplayer.isStickyPanelOpened && isLessThanLG.value;
  })

  return {
    isPlayerOpenAdaptive
  };
}